import { apiClient } from '../client';

export interface GitHubRepository {
    id: number;
    name: string;
    full_name: string;
    html_url: string;
    description: string | null;
    default_branch: string;
    updated_at: string;
}

export interface GitHubBranch {
    name: string;
}

export interface GitHubFile {
    content: string;
    path: string;
    repo: string;
    ref: string;
}

export const githubService = {
    /** List current user's repositories */
    getRepositories: () => 
        apiClient.get<GitHubRepository[]>('/github/repositories'),

    /** List branches for a specific repository */
    getBranches: (repoName: string) =>
        apiClient.get<GitHubBranch[]>(`/github/repositories/${repoName}/branches`),

    /** List contents of a path */
    getContents: (repoName: string, path: string = '', ref: string = 'main') =>
        apiClient.get<any[]>(`/github/repositories/${repoName}/contents`, {
            params: { path, ref }
        }),

    /** Get content of a specific file */
    getFile: (repoName: string, path: string, ref: string = 'main') =>
        apiClient.get<GitHubFile>(`/github/repositories/${repoName}/file`, {
            params: { path, ref }
        }),

    /** Update a file (Commit) */
    updateFile: (repoName: string, data: { path: string, content: string, message: string, branch: string }) =>
        apiClient.put<{ status: string, message: string }>(`/github/repositories/${repoName}/file`, data),
};
